import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=fb0e2d4e&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"
import style0 from "./PanelCard.vue?vue&type=style&index=0&id=fb0e2d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0e2d4e",
  null
  
)

export default component.exports